import { isCacheFresh } from './cache';

// Common per-project cache bucket fields shared by the projectXxx slices.
export interface ProjectBucket {
  isLoading: boolean;
  error: string | null;
  lastFetched: number | null;
}

// Returns the bucket for a project, creating it on first access.
export const ensureProjectBucket = <TBucket extends ProjectBucket>(
  byProjectId: Record<string, TBucket>,
  projectId: string,
  createBucket: () => TBucket
): TBucket => {
  const buckets = byProjectId;

  if (!buckets[projectId]) {
    buckets[projectId] = createBucket();
  }

  return buckets[projectId];
};

// True when the bucket was fetched recently and a refetch can be skipped.
export const isProjectBucketFresh = (bucket: ProjectBucket | undefined, force?: boolean): boolean =>
  !force && isCacheFresh(bucket?.lastFetched);

// Marks a bucket as loading and clears any previous error.
export const markBucketLoading = (bucket: ProjectBucket): void => {
  const targetBucket = bucket;

  targetBucket.isLoading = true;
  targetBucket.error = null;
};

// Marks a bucket as failed with the given message.
export const markBucketError = (bucket: ProjectBucket, message: string): void => {
  const targetBucket = bucket;

  targetBucket.isLoading = false;
  targetBucket.error = message;
};
